<script>
  import {apdate,aptime} from 'journalize';
  import { get_all_dirty_from_scope } from 'svelte/internal';
    /** @type {import('../types.d').ReadableRace} */
    export let race;
   
    $: d = new Date($race[0].time.replace("live: ",""))
    $: time = aptime(d)
    $: date = apdate(d)

    $:final = `${date} ${time}`

  </script>

  <p style="margin:auto; max-width:650px;">Last updated {final}</p>
  